module.exports = __webpack_public_path__ + "a7ffb70494ef47b23012e1d7abee1d63.png";